import whiteLogoImage from '../../assets/images/white_logo.png';
import wxContactImage from '../../assets/images/wx_contact.jpg';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-[clamp(2rem,4vw,3rem)]">
        {/* 主体内容：网格布局响应式，全元素缩放 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-[clamp(1rem,2vw,2rem)]">
          {/* 左侧：公司信息 + 社交图标 */}
          <div className="md:col-span-2">
            {/* Logo + 公司名称：同步缩放，保持对齐 */}
            <div className="flex items-center space-x-[clamp(0.5rem,1vw,0.75rem)] mb-[clamp(1rem,2vw,1.5rem)]">
              <img
                src={whiteLogoImage}
                alt="上海万江环境科技有限公司"
                className="w-[clamp(2rem,4vw,2.5rem)] h-[clamp(2rem,4vw,2.5rem)] object-contain" // 动态尺寸，完整显示
              />
              <span className="text-[clamp(1rem,2vw,1.25rem)] font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                上海万江环境科技有限公司
              </span>
            </div>
            {/* 公司描述：文字动态适配 */}
            <p className="text-gray-400 mb-[clamp(1rem,2vw,1.5rem)] max-w-md text-[clamp(0.75rem,1.2vw,0.875rem)] hover:text-white cursor-pointer transition-colors">
              智慧环境解决方案专家
            </p>
            {/* 社交图标：容器+图标同步缩放 */}
            <div className="flex space-x-[clamp(0.5rem,1vw,1rem)]">
              {[
                { icon: 'ri-wechat-fill', label: '微信公众号', type: 'wechat' },
                { icon: 'ri-phone-fill', label: '联系电话', type: 'phone' },
                { icon: 'ri-mail-fill', label: '联系邮箱', type: 'mail' }
              ].map((item) => (
                <div key={item.type} className="group relative">
                  <button
                    type="button"
                    aria-label={item.label}
                    aria-describedby={`footer-${item.type}-popup`}
                    className="w-[clamp(2rem,4vw,2.5rem)] h-[clamp(2rem,4vw,2.5rem)] rounded-lg flex items-center justify-center transition-colors cursor-pointer hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
                    style={{ backgroundColor: '#4677e0' }}
                  >
                    <i className={`${item.icon} text-white text-[clamp(0.875rem,1.5vw,1rem)]`}></i>
                  </button>
                  <div
                    id={`footer-${item.type}-popup`}
                    role="tooltip"
                    className="absolute bottom-full left-0 z-20 mb-2 hidden rounded-2xl bg-white p-3 text-gray-700 shadow-2xl group-hover:block group-focus-within:block"
                  >
                    {item.type === 'wechat' ? (
                      <div className="text-center">
                        <img src={wxContactImage} alt="微信公众号二维码" className="h-36 w-36 max-w-none rounded-lg object-contain" />
                        <p className="mt-2 whitespace-nowrap text-sm font-medium">扫码关注{item.label}</p>
                      </div>
                    ) : (
                      <div className="whitespace-nowrap text-sm">
                        <p className="mb-1 font-semibold text-gray-900">{item.label}</p>
                        <div className="flex items-center gap-2">
                          <i className={item.type === 'phone' ? 'ri-phone-line' : 'ri-mail-line'}></i>
                          <span>{item.type === 'phone' ? '021-60755700' : 'wanjianghuanjing@163.com'}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 中间：业务领域 */}
          <div>
            <h3 className="text-[clamp(0.875rem,1.5vw,1rem)] font-semibold mb-[clamp(0.75rem,1.5vw,1rem)]">
              业务领域
            </h3>
            <ul className="space-y-[clamp(0.5rem,1vw,0.75rem)] text-gray-400 text-[clamp(0.75rem,1.2vw,0.8125rem)]">
              <li className="hover:text-white cursor-pointer transition-colors">智慧城市与管网解决方案</li>
              <li className="hover:text-white cursor-pointer transition-colors">河湖生态与水环境修复</li>
              <li className="hover:text-white cursor-pointer transition-colors">智慧环境监测设备及软件服务</li>
              <li className="hover:text-white cursor-pointer transition-colors">环保综合服务</li>
            </ul>
          </div>

          {/* 右侧：联系信息 */}
          <div>
            <h3 className="text-[clamp(0.875rem,1.5vw,1rem)] font-semibold mb-[clamp(0.75rem,1.5vw,1rem)]">
              联系信息
            </h3>
            <div className="space-y-[clamp(0.5rem,1vw,0.75rem)] text-gray-400 text-[clamp(0.75rem,1.2vw,0.8125rem)]">
              <div className="flex items-center space-x-[clamp(0.25rem,0.5vw,0.5rem)] hover:text-white cursor-pointer transition-colors">
                <i className="ri-map-pin-line text-[clamp(0.75rem,1.2vw,0.8125rem)]"></i>
                <span>上海市浦东新区秀浦路3188弄创研智造B10-13号</span>
              </div>
              <div className="flex items-center space-x-[clamp(0.25rem,0.5vw,0.5rem)] hover:text-white cursor-pointer transition-colors">
                <i className="ri-phone-line text-[clamp(0.75rem,1.2vw,0.8125rem)]"></i>
                <span>021-60755700</span>
              </div>
              <div className="flex items-center space-x-[clamp(0.25rem,0.5vw,0.5rem)] hover:text-white cursor-pointer transition-colors">
                <i className="ri-mail-line text-[clamp(0.75rem,1.2vw,0.8125rem)]"></i>
                <span>wanjianghuanjing@163.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* 底部版权信息：响应式布局，同步缩放 */}
        <div className="border-t border-gray-800 mt-[clamp(1.5rem,3vw,2rem)] pt-[clamp(1rem,2vw,1.5rem)] flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-[clamp(0.6875rem,1.1vw,0.75rem)] hover:text-white cursor-pointer transition-colors">
            © 2025 上海万江环境科技有限公司. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  );
}
